import CategoryNavigation from '@totallymoney/ui/components/CategoryNavigation'

import { CreditCardAlternativeProductsCategory } from '@appTypes/EligibilityApi.interface'

interface AlternativeProductsTableHeaderProps {
    initialCategory: string
    onCategoryChange: (category: string) => void
    categories: CreditCardAlternativeProductsCategory[]
}

const AlternativeProductsTableHeader = ({
    initialCategory,
    categories,
    onCategoryChange,
}: AlternativeProductsTableHeaderProps) => {
    return (
        <CategoryNavigation
            categories={categories.map(category => ({
                displayName: `${category.displayName} (${category.alternativeProductsCount})`,
                value: category.id,
                url: `/alternative-products`,
            }))}
            initialActiveCategory={initialCategory}
            onCategoryChange={category => {
                onCategoryChange?.(category.value)
            }}
        />
    )
}

export default AlternativeProductsTableHeader
